/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import Avatar, { AvatarItem } from '@atlaskit/avatar';
import { cssMap, cx, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import type { User } from '../../../api/useIssueSearchQuery/types';
import { messages } from '../messages';

const styles = cssMap({
	avatar: {
		marginLeft: token('space.negative.100'),
	},
});

export const IssueUserNode: ({ user }: {
    user?: User | null;
}) => JSX.Element = ({ user }: { user?: User | null }) => {
	const { formatMessage } = useIntl();

	const User = !Boolean(user) ? (
		<AvatarItem
			avatar={<Avatar appearance="circle" size="small" name="unassigned" />}
			primaryText={formatMessage(messages.unassigned)}
		/>
	) : (
		<Tooltip
			content={user?.name}
			// don't need a screen reader announcement as the
			// tooltip content is the same as the items content
			isScreenReaderAnnouncementDisabled
		>
			<AvatarItem
				avatar={<Avatar appearance="circle" src={user?.picture} size="small" name={user?.name} />}
				primaryText={user?.name}
			/>
		</Tooltip>
	);

	return <Box xcss={cx(styles.avatar)}>{User}</Box>;
};
